import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { TooltipPosition } from 'ui-components/components/tooltip/tooltip-position';

import { ChildrenPropType } from '../../../prop-types/children';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

import style from './sidebar-button.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

export const SidebarButton = ({ children, tooltipMessageDescriptor, onClick, isSelected, tooltipMessageValues = emptyObject }) => {
  const intl = useIntl();
  const ariaLabel = intl.formatMessage(tooltipMessageDescriptor, tooltipMessageValues);

  return (
    <Tooltip position={TooltipPosition.Right}>
      <span>
        <Button
          ariaLabel={ariaLabel}
          className={classnames(style['sidebar-button'], {
            [style.selected]: isSelected,
          })}
          onClick={onClick}
          theme='unstyled'
        >
          {children}
        </Button>
      </span>
      <TooltipContent>
        <FormattedMessage {...tooltipMessageDescriptor} values={tooltipMessageValues} />
      </TooltipContent>
    </Tooltip>
  );
};

SidebarButton.propTypes = {
  children: ChildrenPropType.isRequired,
  tooltipMessageDescriptor: MessageDescriptorPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  tooltipMessageValues: PropTypes.object,
};
